import { render, staticRenderFns } from "./ArticleOrigin.vue?vue&type=template&id=696928be&"
import script from "./ArticleOrigin.vue?vue&type=script&lang=js&"
export * from "./ArticleOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports